export default "__VITE_ASSET__Chz82P_M__"